// extracted by mini-css-extract-plugin
module.exports = {"actions":"actions--N8iG-","titleActions":"titleActions--OWn7v"};